<td [attr.colspan]="colSpan" class="text-center py-2">
    @if (noLoadedData) {
        {{ 'shared.noDataAvailable' | translate }}
    } @else {
        {{ 'shared.noDataFilter' | translate }}
    }
</td>
